import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = [
    "data-aside-collapsed",
    "data-fullscreen"
];
const _hoisted_2 = {
    class: "pe-layout-pc-container"
};
const _hoisted_3 = {
    class: "pe-layout-main"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_HeaderNav = _resolveComponent("HeaderNav");
    const _component_Menu = _resolveComponent("Menu");
    return _openBlock(), _createElementBlock("div", {
        class: "pe-layout-pc-wrapper",
        "data-aside-collapsed": _ctx.isAsideCollapsed,
        "data-fullscreen": _ctx.isFullscreen
    }, [
        _withDirectives(_createVNode(_component_HeaderNav, {
            fixed: ""
        }, null, 512), [
            [
                _vShow,
                !_ctx.isFullscreen
            ]
        ]),
        _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createVNode(_component_Menu, {
                onCollapseStatusChange: _ctx.handleCollapseStatusChange
            }, null, 8, [
                "onCollapseStatusChange"
            ]), [
                [
                    _vShow,
                    !_ctx.isFullscreen
                ]
            ]),
            _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ])
        ])
    ], 8, _hoisted_1);
}
